// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2AH2y","name":"Header_name__R2XLR","birthday":"Header_birthday__3xiHd","skeleton":"Header_skeleton__2LEJg"};